var Modal = require("components/utility/AltModal");
var CurrentUser = require('lib/account/CurrentUser');
var NewFeatureInfo = require("components/notifications/new_features/NewFeatureInfo")
var Features = require("lib/account/Features");

require("notifications/new_features_modal.scss");

class NewFeaturesModal extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        LuckyOrangeClient.tagComponent("NewFeaturesModal");

        this.state = {
            track: this.createTrack(),
            stageIndex: 0,
            hide: false
        };
    }

    ///// HELPERS /////
    createTrack() {
        return _.filter(NEW_FEATURES, (f) => {
            if (f.conditions() && f.active) { return f }
        })
    }

    retreatePossible() {
        var { stageIndex } = this.state
        return stageIndex > 0
    }

    nextPossible() {
        var { stageIndex, track } = this.state
        return _.size(track) - 1 > stageIndex
    }

    donePossible() {
        var { stageIndex, track } = this.state
        return _.size(track) - 1 == stageIndex
    }

    deleteAlert() {
        if (this.props.alertID) {
            CurrentUser.api().deleteUserAlert(this.props.alertID, (res) => {
                this.setState({ hide: true });

                var newUserAlerts = _.filter(CurrentUser.get().user_alerts, alert => { return alert.data.annoucement_key !== res.user_alert.data.annoucement_key })
                CurrentUser.updateLocal({ user_alerts: newUserAlerts })
            });
        }
    }

    ///// STAGE CONTROLLERS /////
    getStageCount() {
        return this.state.track.length;
    }

    getCurrentStageData() {
        return this.state.track[this.state.stageIndex];
    }

    getStageTitle() {
        var currentStageData = this.getCurrentStageData();

        return currentStageData.title;
    }

    ///// HANDLERS /////

    handleCloseModal() {
        this.refs.newFeaturesModal.hide();
        this.deleteAlert()
    }

    // handles next button
    handleAdvanceStage() {
        var newStageIndex = this.state.stageIndex + 1;
        this.setState({ stageIndex: newStageIndex })
    }

    // handles back button
    handleRetreatStage() {
        var newStageIndex = this.state.stageIndex - 1;
        this.setState({ stageIndex: newStageIndex })
    }

    ///// RENDER METHODS /////
    renderContent() {
        var currentStageData = this.getCurrentStageData();
        return (
            <currentStageData.display
                {...currentStageData.props}
                track={this.state.track}
                onRetreat={this.handleRetreatStage}
                onComplete={this.handleAdvanceStage}
            />
        )
    }
    render() {
        if (this.state.hide) { return null }
        return (
            <Modal onHide={this.deleteAlert} headerText={this.getStageTitle()} className="newFeaturesModal" ref="newFeaturesModal">
                <div className="newFeaturesModal">
                    {this.renderContent()}
                    <div className="buttonContainer">
                        {this.retreatePossible() && (
                            <button className='backBtn' onClick={() => this.handleRetreatStage()}>Back</button>
                        )}
                        {this.nextPossible() && (
                            <button className='nextBtn' onClick={() => this.handleAdvanceStage()}>Next</button>
                        )}

                        {this.donePossible() && (
                            <button className='closeBtn' onClick={() => this.handleCloseModal()}>Close</button>
                        )}
                    </div>
                </div>
            </Modal>
        );
    }

    componentDidMount() {
        this.refs.newFeaturesModal.show();
    }
}

// Configs for new features
// Future users can add new features by adding an object to the NEW_FEATURES array with the following properties:
// active: whether the feature is currently active or not
// name: a unique identifier for the feature
// title: the display name for the feature
// display: the React component to use for displaying the feature
// conditions: a function that returns a boolean indicating whether the feature should be displayed
// props: an object containing any additional properties required by the React component used for displaying the feature, such as image path and descriptions.
var NEW_FEATURES = [
    {
        active: true,
        name: 'improved-exports',
        title: 'Enhanced Data Export Feature',
        display: NewFeatureInfo,
        conditions: () => { return Features.isEnabled(Features.DIGITAL_EXERCISES) },
        props: {
            imagePath: 'features/data_exports.gif',
            descriptions: [
                'Now you have the ability to tailor your exports by selecting specific time periods, students, and metrics that best fit your needs.',
                "You can now input your email address and receive the customized XLS export straight to your mailbox for easy accessibility.",
                "Furthermore, we made improvements to the layout of data on printable PDF pages, ensuring that they are now more legible and presentable when printed.",
            ]
        }
    },
    {
        active: true,
        name: 'improved-insights',
        title: 'Discover More with our Upgraded Insights Page',
        conditions: () => { return true },
        display: NewFeatureInfo,
        props: {
            imagePath: 'features/insights_page.gif',
            descriptions: [
                "Admins can now see scoring trends for individual students, gaining insights into student performance over time with easy-to-view scoring trends.",
                "It is also now possible to monitor the activity of both classes and individual students all year round, which enables you to gain valuable insights into their performance and adjust instruction as needed."
            ]
        }
    },
]

NewFeaturesModal.propTypes = StrictPropTypes({
    onComplete: PropTypes.func,
    effectiveData: PropTypes.object,
    handlePrint: PropTypes.func,
    track: PropTypes.array,
    alertID: PropTypes.number
});

module.exports = NewFeaturesModal;


// WEBPACK FOOTER //
// ./modules/components/notifications/new_features/NewFeaturesModal.js